import { authAxios } from '@components/Auth';
import { API_V1_BASE } from '@config';
import { DiagnosisCode } from '@models/DiagnosisCode';

export class DiagnosisCodeApi {
  static search = async (search: string) => {
    return await authAxios
      .get(`${API_V1_BASE}/diagnosis_codes`, { params: { search } })
      .then((response) => response.data as DiagnosisCode[]);
  };
}
